import Image from '@/models/image';
import i18n from '@/translations/i18n';
import { IngredientProps, IngredientUnits } from '@/interfaces/models/ingredient';
import assetsUtils from '@/utils/url.utils';
import { v4 } from 'uuid';

export default class Ingredient {
  cost: number = 0;
  count: number = 1;
  id: string = '';
  image: Image = new Image();
  name: string = '';
  description: string = '';
  posCode?: number;
  unit: IngredientUnits = IngredientUnits.GRAM;
  unitCount: number = 1;
  projectIngredient: { id: string } | null = null;
  uniqId = v4();

  [key: string]: any;

  public static createFromRequest(ingredientProps: IngredientProps): Ingredient {
    const ingredient = new Ingredient();

    ingredient.cost = ingredientProps.cost;

    if (ingredientProps.count) {
      ingredient.count = ingredientProps.count;
    }

    ingredient.id = ingredientProps.id;

    if (ingredientProps.image) {
      ingredient.image = new Image(ingredientProps.image);
    }

    ingredient.name = ingredientProps.name;
    ingredient.description = ingredientProps.description;
    ingredient.posCode = ingredientProps.posCode;
    ingredient.unit = ingredientProps.unit;
    ingredient.unitCount = ingredientProps.unitCount;
    ingredient.projectIngredient = ingredientProps.projectIngredient;

    return ingredient;
  }

  public static createByName(name: string = ''): Ingredient {
    const ingredient = new Ingredient();

    ingredient.name = name;

    return ingredient;
  }

  public get hash() {
    return `${this.id}-cost:${this.cost}-unit-count-${this.unitCount}`;
  }

  get unitTranslate() {
    switch (this.unit) {
      case IngredientUnits.GRAM:
        return i18n.t('menu.ingredient.unitName.grams');
      case IngredientUnits.MILLILITER:
        return i18n.t('menu.ingredient.unitName.milliliters');
      default:
        return i18n.t('menu.ingredient.unitName.unit');
    }
  }

  get unitCategoryTranslate() {
    switch (this.unit) {
      case IngredientUnits.GRAM:
        return i18n.t('menu.ingredient.unitCategory.weight');
      case IngredientUnits.MILLILITER:
        return i18n.t('menu.ingredient.unitCategory.volume');
      default:
        return i18n.t('menu.ingredient.unitCategory.count');
    }
  }

  get preview(): URL {
    if (this.image.original && this.image.path) {
      return assetsUtils.generateAssetsUrl(this.image.path);
    }

    return require('../assets/images/product-placeholder.png');
  }

  public mergeWithNewFields(ingredientProps: IngredientProps) {
    for (let key in ingredientProps) {
      if (ingredientProps.hasOwnProperty(key) && this.hasOwnProperty(key)) {
        switch (key) {
          case 'image': {
            if (ingredientProps.image) {
              this.image = new Image(ingredientProps.image);
            } else {
              this.image = new Image();
            }

            break;
          }

          default: {
            this[key] = ingredientProps[key];
          }
        }
      }
    }
  }

  public increment() {
    this.count++;
  }

  public removeImage() {
    this.image = new Image();
  }
}
